import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { StatisticsListPayload } from '@/models/statistics/statistics-list-payload.model';
import { StatisticsListItem } from '@/models/statistics/statistics-list.model';
import { clearObj } from '@marfa/bo-utils';

export default class GetStatisticsListRequest extends ApiResourceMethod<StatisticsListItem[]> {
  public perform(whitelabelSlug: string, requestPayload: StatisticsListPayload): Promise<StatisticsListItem[]> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/report/statistic`,
        params: clearObj(requestPayload),
      },
      ({ data }: BaseResponse<StatisticsListItem[]>): StatisticsListItem[] => data,
    );
  }
}
